module.exports = __webpack_public_path__ + "static/media/starIcon.193fcf8f.svg";